import { Button, ProgressIndicator } from '@veneer/core';
import React, { useEffect, useMemo, useState } from 'react';
import { ScreenInfo, useDataCollection } from '../../jarvis/dataCollection';
import ModalError, { ModalErrorDetail } from '../Modals/Error';
import './index.css';

import type { CseExperimentData } from '../../types';

interface LandingProps {
  cseExperimentsData?: CseExperimentData;
  onClickLaunchDesigner: React.MouseEventHandler<'button'>;
}
const valuePropPlaceholder = {
  title: 'Title',
  body1: 'Body 1',
  product: 'Product',
  body2: 'Body 2',
  button: 'Button',
  files: {
    image: '',
  },
};

const Landing = (props: LandingProps) => {
  const [hasError, setHasError] = useState(false);
  const [errorDetail, setErrorDetail] = useState<ModalErrorDetail>();

  const [isLoading, setIsLoading] = useState(true);
  const dataCollection = useDataCollection();

  const content = useMemo(() => {
    if (props.cseExperimentsData?.valueProp) {
      return props.cseExperimentsData?.valueProp;
    } else {
      return valuePropPlaceholder;
    }
  }, [props.cseExperimentsData?.valueProp]);

  const screenInfo: ScreenInfo = {
    name: 'ValueProposition',
    activity: 'PhotobookValueProposition-v01',
  };
  const continueButtonName = 'ContinueButton';
  const sendClickEvent = (controlName: string) => {
    dataCollection.sendControlClickedEvent({ name: controlName, detail: getWebAppVersion() }, screenInfo);
  };
  const getWebAppVersion = () => process.env['REACT_APP_PACKAGE_VERSION'];

  useEffect(() => {
    try {
      dataCollection.sendScreenViewEvent(screenInfo);
      reportWebAppVersion();
      setIsLoading(false);
    } catch (error) {
      setErrorDetail({
        context: 'Unable to load ValueProp content',
        ...(error instanceof Error && { error: error }),
      });
      setHasError(true);
    }
  }, [dataCollection]);

  const reportWebAppVersion = () => {
    console.log('Landing::reportWebAppVersion: %s', getWebAppVersion());
  };

  const handleContinueClick: React.MouseEventHandler<'button'> = (event) => {
    sendClickEvent(continueButtonName);
    props.onClickLaunchDesigner(event);
  };

  if (hasError) {
    return <ModalError state={hasError} detail={errorDetail as ModalErrorDetail} screenInfo={screenInfo} />;
  }

  if (isLoading) {
    return (
      <div className="spinner">
        <ProgressIndicator />
      </div>
    );
  }

  return (
    <div className="ValuePropPage">
      <div className="banner">
        <h1 className="title">{content.title}</h1>
        <p className="body1">{content.body1}</p>
      </div>
      <div className="imageContainer">
        <img className="image" src={content.files?.image} />
      </div>
      <div className="description">
        <h2 className="product">{content.product}</h2>
        <p className="body2">{content.body2}</p>
        <Button className="button" onClick={handleContinueClick}>
          {content.button}
        </Button>
      </div>
    </div>
  );
};

export default Landing;
